import moment from 'moment';

export const ColorMap = {
  'ORDER CREATED': 'blue',
  'PENDING DO UPLOAD': 'green',
  'PENDING SIGN DO UPLOAD': 'green',
  'UPLOAD SIGN DO': 'green',
  'PENDING DELIVERY': 'orange',
  'PENDING APPROVAL': 'orange',
  'PO CANCELLED': 'red',
  REJECTED: 'red',
  'PENDING REJECTION': 'red',
  'AUTO CREATE SPID': 'cyan',
  CANCELLED_FROM_MP: 'red',
  APPROVED: 'green',
  COMPLETED: 'green',
  'COMPLETED TENTATIVE': 'green',
  'PENDING INVOICE SUBMISSION': 'orange',
  'PENDING PAYMENT': 'orange',
  PARTIALLY_PAID: '#808000',
  PAID: 'green',
  REFUNDED: 'red',
  'ADDED TO MARKETPLACE': 'black',
  PURCHASED: 'black',
  OOS: 'black',
};
export enum OrderOperationStatus {
  ORDER_CREATED = 'ORDER CREATED',
  AUTO_CREATE_SPID = 'AUTO CREATE SPID',
  PENDING_APPROVAL = 'PENDING APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING_REJECTION = 'PENDING REJECTION',
  PENDING_DELIVERY = 'PENDING DELIVERY',
  PENDING_DO_UPLOAD = 'PENDING DO UPLOAD',
  UPLOAD_SIGN_DO = 'UPLOAD SIGN DO',
  PENDING_SIGN_DO_UPLOAD = 'PENDING SIGN DO UPLOAD',
  PO_CANCELLED = 'PO CANCELLED',
  COMPLETED = 'COMPLETED',
  COMPLETED_TENTATIVE = 'COMPLETED TENTATIVE',
  CANCELLED_FROM_MP = 'CANCELLED_FROM_MP',
}

export enum OrderShippingStatus {
  OrderCreated = 'OrderCreated',
  PickedUpFromMerchant = 'PickedUpFromMerchant',
  PickupFailed = 'PickupFailed',
  ParcelProcessing = 'ParcelProcessing',
  InTransit = 'InTransit',
  ReSchedulePickup = 'ReSchedulePickup',
  Remitted = 'Remitted',
  GenerateDeliveryNote = 'GenerateDeliveryNote',
  DeliveryNoteAccepted = 'DeliveryNoteAccepted',
  UploadSignedDelivery = 'UploadSignedDelivery',
}

export enum OrderPaymentStatus {
  PENDING_INVOICE_SUBMISSION = 'PENDING INVOICE SUBMISSION',
  INVOICE_DISPUTED = 'INVOICE_DISPUTED',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PENDING_PAYMENT = 'PENDING PAYMENT',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
}

export const formatOrder = defaultValue => {
  const defaultFormValues = {
    numbers: [''],
    payment_status: OrderPaymentStatus.PENDING_INVOICE_SUBMISSION,
    operation_status: OrderOperationStatus.ORDER_CREATED,
    attachments: [],
    items: [{ name: '', quantity: 1, total: 0, price: 0 }],
    tax: 0,
    handling_fee: 0,
    is_excluded_from_reports: false,
    is_excluded_from_xero_sync: false,
    is_region_tax: true,
  };

  const initialValues = defaultValue
    ? {
        ...defaultFormValues,
        ...defaultValue,
        issue_date: defaultValue.issue_date
          ? moment.utc(defaultValue.issue_date)
          : undefined,
        invoice_date: defaultValue.invoice_date
          ? moment.utc(defaultValue.invoice_date)
          : undefined,
        attachments: defaultValue.attachments
          ? defaultValue.attachments.map(item => ({
              url: item.thumb_url,
              name: item.name,
              status: 'done',
              uid: item.id,
              id: item.id,
            }))
          : [],
        items: defaultValue.items.map(item => {
          let itemTax = item.tax_rate || 0;
          if (!itemTax && defaultValue?.is_region_tax) {
            itemTax = defaultValue.tax_rate || 0;
          }

          return {
            ...item,
            label: item.name,
            key: item.external_id,
            cost: item.discount_price || item.price,
            total: Number(Number(item.total * (1 + itemTax / 100)).toFixed(4)),
            supplier_id: item.supplier_id,
          };
        }),
        has_attachment_po: !!defaultValue.has_attachment_po,
      }
    : defaultFormValues;

  return initialValues;
};
